import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'
import UIProfileDoneModal, { UIPropfileDoneModalProps } from '@web/ui/components/ProfileDoneModal'
import styles from '@web/ui/components/ProfileDoneModal/ProfileDoneModal.module.scss'

const ProfileDoneModal: ModalComponent<UIPropfileDoneModalProps> = ({
  showModal,
  confirmModal,
  hasReview,
  nickname,
  profileImageUrl,
}) => {
  return (
    <ModalContainer showModal={showModal} className={styles.modal_container} position="bottom">
      <UIProfileDoneModal
        hasReview={hasReview}
        nickname={nickname}
        profileImageUrl={profileImageUrl}
        onConfirm={confirmModal}
      />
    </ModalContainer>
  )
}

export default ProfileDoneModal
